/*
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 *
 * Copyright: 2023 by Idemia Identity & Security USA LLC. All rights reserved.
 * License: In accordance  Idemia I&S USA LLC's license agreement.
 * Code Classification: GOVERNMENT
 *
 * Classification Person: Nadim Bakizada nadim.bakizada@us.idemia.com
 * Classification Reason: Software not specific to any U.S. Government Entity
 * Classification Date: 2023
 *
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 */

import ReactDOM from "react-dom/client";
import './index.scss';
import { router } from "./App";
import reportWebVitals from "./reportWebVitals";
import { CookiesProvider } from "react-cookie";
import { CacheProvider } from '@emotion/react';
import { RouterProvider } from "react-router-dom";
import { ThemeProvider_MUI } from "theme/ThemeProvider";
import { IdleTracker } from "./components/Idle-Tracker/idle-tracker";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import cache from './emotionCache';
if (process.env.NODE_ENV !== "development") console.log = () => { };

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
    <CacheProvider value={cache}>
      <CookiesProvider>
        <ThemeProvider_MUI>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <IdleTracker />
            <RouterProvider router={router} />
          </LocalizationProvider>
        </ThemeProvider_MUI>
      </CookiesProvider>
    </CacheProvider>
);

reportWebVitals();
